import { Box } from '@chakra-ui/react';
import React from 'react';

export const RouteTemplate = ({
  children,
}: {
  children: React.ReactChild | React.ReactChild[];
}) => {
  return (
    <Box
      padding={{ base: '30px', lg: '50px 40px' }}
      margin="0 auto"
      width="100%"
      maxWidth="1600px"
    >
      {children}
    </Box>
  );
};

export const FullWidthRouteTemplate = ({
  children,
}: {
  children: React.ReactChild | React.ReactChild[];
}) => {
  return (
    <Box padding="32px" width="100%" overflowX="auto">
      {children}
    </Box>
  );
};
